// extracted by mini-css-extract-plugin
export default {"bigButton":"Button_bigButton__ll8cC","title":"Button_title__OKssy"};